import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "@app/core/change-password/change-password.component";
import { CoreRouterModule } from "@app/core/core.routing";
import { HeaderComponent } from "@app/core/header/header.component";
import { MainComponent } from "@app/core/main.component";
import { PasswordRecoveryComponent } from "@app/core/password-recovery/password-recovery.component";
import { PaymentSuccessComponent } from "@app/core/payment-success/payment-success.component";
import { RegistrationComponent } from "@app/core/registration/registration.component";
import { ServerMaintenanceComponent } from "@app/core/server-maintenance/server-maintenance.component";
import { SpinnerModule } from "@app/core/spinner/spinner.module";
import { UserSignupComponent } from "@app/core/user-signup/user-signup.component";
import { FormxInputComponent } from "@shared/component/formx-input/formx-input.component";
import { AdminService } from "@shared/services/admin/admin.service";
import { AlertMessageService } from "@shared/services/alert-message/alert-message.service";
import { AuctionService } from "@shared/services/auction/auction.service";
import { CodeTableService } from "@shared/services/code-table/code-table.service";
import { DealerService } from "@shared/services/dealers/dealer.service";
import { FileService } from "@shared/services/file/file.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { OpenApiService } from "@shared/services/open/open-api.service";
import { ScriptService } from "@shared/services/script.service";
import { ShowcaseService } from "@shared/services/showcase/showcase.service";
import { SnackbarService } from "@shared/services/snackbar.service";
import { SnackBarComponent } from "@shared/services/snackbar/snackbar.component";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { TemplateService } from "@shared/services/template/template.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { UsersService } from "@shared/services/users/users.service";
import { VehicleService } from "@shared/services/vehicle/vehicle.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";
import { VerifyConsentsComponent } from "./verify-consents/verify-consents.component";

@NgModule({
	declarations: [
		HeaderComponent,
		RegistrationComponent,
		MainComponent,
		PasswordRecoveryComponent,
		UserSignupComponent,
		ServerMaintenanceComponent,
		PaymentSuccessComponent
	],
	imports: [
		ChangePasswordComponent,
		VerifyConsentsComponent,
		CommonModule,
		SharedModule,
		CoreRouterModule,
		SpinnerModule,
		ReactiveFormsModule,
		FormxInputComponent,
		SnackBarComponent
	],
	exports: [
		SpinnerModule
	],
	providers: [
		AdminService,
		AlertMessageService,
		AuctionService,
		CodeTableService,
		DealerService,
		FileService,
		MqttService,
		OpenApiService,
		ScriptService,
		ShowcaseService,
		SnackbarService,
		StorageManagerService,
		TemplateService,
		UserApiService,
		UsersService,
		VehicleService,
		WcmService
	],
	bootstrap: [MainComponent]
})
export class CoreModule {}